import { render, staticRenderFns } from "./TopTitle.vue?vue&type=template&id=f449d872&scoped=true&"
import script from "./TopTitle.vue?vue&type=script&lang=js&"
export * from "./TopTitle.vue?vue&type=script&lang=js&"
import style0 from "./TopTitle.vue?vue&type=style&index=0&id=f449d872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f449d872",
  null
  
)

export default component.exports